import { render } from "./ListPagination.vue?vue&type=template&id=9ff73d4c&bindings={\"cursor\":\"props\",\"npages\":\"props\",\"showListPage\":\"options\"}"
import script from "./ListPagination.vue?vue&type=script&lang=js"
export * from "./ListPagination.vue?vue&type=script&lang=js"
script.render = render

export default script